import React from "react"

import { useTranslation } from "react-i18next"

import { BonusPerformance } from "services/bonus/type"

import { formatFiatCurrency } from "util/formatter"

import { getBonusTypeColor,getDisplayName } from "../../helpers/bonus2.helpers"

interface Props {
  bonusPerformance: BonusPerformance[]
}

export const TopPerformingBonuses = ({ bonusPerformance }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  return (
    <div className="rounded-3xl border p-6 border-[rgba(0,0,0,0.05)] bg-white backdrop-blur-[9px] shadow-[0px_3px_6px_0px_rgba(192,192,192,0.6)] dark:border-[rgba(255,255,255,0.1)] dark:bg-[rgba(255,255,255,0.04)] dark:backdrop-blur-md dark:shadow-none">
      <h4 className="font-semibold mb-4 text-[rgba(6,7,21,1)] dark:text-white">{t("bonus2.analytics.topPerformingBonuses")}</h4>
      {bonusPerformance.length === 0 ? (
        <div className="text-center py-4 text-gray-400 dark:text-gray-500">{t("bonus2.analytics.noBonusActivationsIn")}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-[rgba(0,0,0,0.2)]">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.bonus")}</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.type")}</th>
                <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.activations")}</th>
                <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.completions")}</th>
                <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.rate")}</th>
                <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 dark:text-gray-300">{t("bonus2.analytics.totalValue")}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {bonusPerformance.map((bonus) => (
                <tr key={bonus.id}>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <span className="text-[rgba(6,7,21,1)] dark:text-white">{getDisplayName(bonus.name)}</span>
                      {!bonus.active && <span className="text-rose-400 text-xs">(inactive)</span>}
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 text-xs rounded text-white ${getBonusTypeColor(bonus.type)}`}>{bonus.type}</span>
                  </td>
                  <td className="px-4 py-3 text-right text-[rgba(6,7,21,1)] dark:text-white">{bonus.activations}</td>
                  <td className="px-4 py-3 text-right text-emerald-500">{bonus.completions}</td>
                  <td className="px-4 py-3 text-right">
                    <span
                      className={
                        bonus.completionRate >= 50 ? "text-emerald-500" : bonus.completionRate >= 25 ? "text-yellow-500" : "text-rose-500"
                      }
                    >
                      {bonus.completionRate.toFixed(1)}%
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right text-primary">{formatFiatCurrency(bonus.totalValue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
